// extracted by mini-css-extract-plugin
module.exports = {"scrollUpButton":"components-scrollUpButton-scrollUpButton__scrollUpButton--XIiqD"};